import { render, staticRenderFns } from "./UserRating.vue?vue&type=template&id=5cca9ea6&scoped=true"
import script from "./UserRating.vue?vue&type=script&lang=ts"
export * from "./UserRating.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cca9ea6",
  null
  
)

export default component.exports